module.exports = __webpack_public_path__ + "img/a1.4ae4d972.png";